import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import HowToRegIcon from '@mui/icons-material/HowToReg'
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium'
import { Box, Button } from '@mui/material'
import esocialImage from 'assets/brazil-stamp.svg'
import logoImage from 'assets/logo-icon.png'
import ImageBanner from 'components/image-banner'
import SecuritySVG from 'components/svg/security'
import WrapperPermission from 'components/wrapper-permission'
import { useAuth } from 'contexts/auth'
import { useHistory } from 'react-router-dom'
import OrganizationInfo from '../organization-info'
import { useStyles } from './styles'

const EsocialConnect = () => {
  const classes = useStyles()

  const history = useHistory()

  const { user, skipUploadCertificate, updateUserData } = useAuth()

  const esocialConnection = (icon: any, title: string, description: string, href: string) => {
    return (
      <Box
        className={classes.connectionBox}
        display='flex'
        flexDirection='column'
        justifyContent='space-between'
      >
        <Box
          display='flex'
          flexDirection='column'
        >
          {icon}

          <p className={classes.textTitle}>{title}</p>
          <p className={classes.textSubTitle}>{description}</p>
        </Box>

        <Button
          variant='text'
          size='large'
          sx={{ mt: 4, height: '42px', textAlign: 'left', width: 100 }}
          onClick={() => history.push(href)}
        >
          Conectar
        </Button>
      </Box>
    )
  }

  const handleSkipUpload = async () => {
    skipUploadCertificate()
    // Atualiza os dados do usuário antes de redirecionar para garantir que emailIsConfirmed está correto
    await updateUserData()
    await history.push('/redirect')
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box className={classes.connectBox}>
            <Box
              display='flex'
              alignItems='center'
            >
              <img
                src={logoImage}
                alt='Conducco'
                className={classes.logoImage}
              />
              <ArrowForwardIcon style={{ color: '#707974' }} />
              <img
                src={esocialImage}
                alt='E-Social'
                height={48}
                style={{ marginLeft: '12px' }}
              />
            </Box>

            <p className={classes.formTitle}>Conectar com eSocial</p>
            <p className={classes.formSubTitle}>
              A integração com o eSocial permite que todos os seus eventos sejam sincronizados.
            </p>

            <OrganizationInfo
              organizationName={user!.organization?.name as string}
              organizationFederalTaxId={user!.organization?.cnpj as string}
            />

            <Box
              display='flex'
              gap='16px'
              width='100%'
            >
              {esocialConnection(
                <WorkspacePremiumIcon style={{ fontSize: '48px', color: '#3024E1' }} />,
                'Conectar com Certificado Digital A1',
                'Conectar ao eSocial com um Certificado Digital A1',
                '/certificate-upload'
              )}
              {esocialConnection(
                <HowToRegIcon style={{ fontSize: '48px', color: '#3024E1' }} />,
                'Conectar com Procuração e-CAC',
                'É necessário ter uma procuração eletrônica registrada na Receita Federal.',
                '/loa-esocial'
              )}
            </Box>

            <p className={classes.textFoot}>
              Você não é responsável por essas informações? Clique no botão abaixo e convide a pessoa encarregada de
              cadastrar essas informações.
            </p>

            <Box
              marginTop='32px'
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              width='100%'
            >
              <Button
                color='inherit'
                variant='outlined'
                onClick={async () => await handleSkipUpload()}
                sx={{
                  borderColor: '#000000 !important',
                  color: '#000000 !important',
                  height: '42px',
                  padding: '0 2rem',
                }}
              >
                Pular esta etapa
              </Button>

              <Button
                variant='contained'
                onClick={() => history.push('/invite-responsible')}
                sx={{
                  backgroundColor: '#31F7FF !important',
                  color: '#000000 !important',
                  height: '42px',
                  padding: '0 2rem',
                }}
              >
                Convidar responsável
              </Button>
            </Box>
          </Box>
        </WrapperPermission>

        <ImageBanner
          title='Sincronize seus dados do eSocial com o Cofre Digital da Conducco com segurança e praticidade.'
          banner={<SecuritySVG />}
        />
      </Box>
    </Box>
  )
}

export default EsocialConnect
